import Vue from 'vue'
import Vuex from 'vuex'

import ui from './ui'
import auth from './auth'
import options from './options'
import lookups from './lookups'
import modelli from './modelli'
import dichiarazioni from './dichiarazioni'
import notifiche from './notifiche'
import istanze from './istanze'
import incarichi from './incarichi'
import abilitazioni from './abilitazioni'
import redditiPatrimonio from './redditiPatrimonio'
import bollettini from './bollettini'
import comunicazioni from './comunicazioni'
import estratticonto from './estratticonto'
import incassi from './incassi'
import normative from './normative'
import messages from './messages'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    ui,
    auth,
    options,
    lookups,
    modelli,
    dichiarazioni,
    istanze,
    incarichi,
    abilitazioni,
    redditiPatrimonio,
    bollettini,
    comunicazioni,
    estratticonto,
    incassi,
    messages,
    notifiche,
    normative
  }
})

export default store
